import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
import {
    ResponseJsonKeyEnum,
    type AvailabilityResultDateType,
    type CalendarMonthType,
} from '@/Shared/AutoGenerated/Main'

export default class ApiResponseType {
    constructor(private readonly data: any) {}

    getStatus(): string | null {
        const data = this.data

        if (typeof data !== 'object') {
            return null
        }

        const status = data.status

        if (typeof status === 'string') {
            return status
        }

        return null
    }

    getMessage(): string | null {
        const data = this.data

        if (typeof data !== 'object') {
            return null
        }

        const message = data.message

        if (typeof message === 'string') {
            return message
        }

        return null
    }

    getObjectFromPayload(key: ResponseJsonKeyEnum): object {
        const data = this.data

        if (typeof data !== 'object') {
            throw new Error('Data should be an object')
        }

        const payload = data.payload

        if (typeof payload !== 'object') {
            throw new Error('Payload should be an object')
        }

        if (!(key in payload)) {
            throw new Error(`Key '${key}' not found`)
        }

        const content = payload[key] ?? null

        if (typeof content !== 'object') {
            throw new Error('Content should be an object')
        }

        return content
    }

    getArrayFromPayload(key: ResponseJsonKeyEnum): any[] {
        const data = this.data

        if (typeof data !== 'object') {
            throw new Error('Data should be an object')
        }

        const payload = data.payload

        if (typeof payload !== 'object') {
            throw new Error('Payload should be an object')
        }

        if (!(key in payload)) {
            throw new Error(`Key '${key}' not found`)
        }

        const content = payload[key] ?? null

        if (!Array.isArray(content)) {
            throw new Error('Content should be an array')
        }

        return content
    }

    getStringFromPayload(key: ResponseJsonKeyEnum): string {
        const content = this.data.payload[key] ?? null

        if (typeof content !== 'string') {
            throw new Error('Content should be a string', { cause: this.data })
        }

        return content
    }

    // ------------------------------------------------
    // Hydrator helper methods
    // ------------------------------------------------

    getHydrateCalendarMonths(key: ResponseJsonKeyEnum): CalendarMonthType[] {
        const data = this.getObjectFromPayload(key)

        return data as CalendarMonthType[]
    }

    getHydratedAvailabilityResultDates(
        key: ResponseJsonKeyEnum,
    ): AvailabilityResultDateType[] {
        const data = this.getArrayFromPayload(key)

        return data as AvailabilityResultDateType[]
    }

    getHydratedCompanyUserAggregates(
        key: ResponseJsonKeyEnum,
    ): CompanyUserAggregate[] {
        const data = this.getArrayFromPayload(key)

        return CompanyUserAggregate.hydrateMultiple(data)
    }
}
